import React from 'react'
import { DeliveryProps, FetchDeliveries } from '../../types/Orders'
import OrdersDropDown from '../DropDowns/OrdersDropDown'
import { t } from 'i18next'
import { checkedItems } from '../../types'

interface TableProps {
  checkedItems: checkedItems[],
  setCheckedItems: React.Dispatch<React.SetStateAction<checkedItems[]>>
  searchQuery: string,
  searchResult: DeliveryProps[] | undefined,
  allDeliveries?: FetchDeliveries,
  setSelectedIdForDelete: React.Dispatch<React.SetStateAction<string>>
  setDeleteConfPopup: React.Dispatch<React.SetStateAction<boolean>>
  setFailMsg: React.Dispatch<React.SetStateAction<string>>
  direction: string
  startingIndex: number
  permissions: {
    create: boolean,
    view: boolean,
    delete: boolean,
  }
}



const OrdersTable = ({ checkedItems, setCheckedItems, permissions, direction, searchQuery, searchResult, allDeliveries, setSelectedIdForDelete, setDeleteConfPopup, startingIndex }: TableProps) => {

  const handleCheckAll = () => {
    if (allDeliveries?.allDeliveries.length !== checkedItems.length) {
      allDeliveries !== undefined && setCheckedItems(allDeliveries?.allDeliveries.map(delivery => ({ id: delivery.id })))
    } else {
      setCheckedItems([])
    }
  };

  const handleCheck = (id: string) => {
    const isItemExist = checkedItems.some(item => item.id === id);

    if (isItemExist) {
      const newChckedItems = checkedItems.filter(item => item.id !== id);
      setCheckedItems(newChckedItems);
    } else {
      setCheckedItems([...checkedItems, { id: id }])
    }
  };

  return (
    <table className="w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          <th scope="col" className="header-check-box px-4 py-3.5 text-sm text-left text-gray-500 rtl:text-right">
            <div className='relative flex'>
              <input type="checkbox" checked={allDeliveries?.allDeliveries.length === checkedItems.length} onChange={handleCheckAll} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
              <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
          </th>

          <th scope="col" className="px-3 py-3 text-sm font-semibold text-left text-gray-500 whitespace-nowrap rtl:text-right">
            {t('orderNumber')}
          </th>

          <th scope="col" className="px-3 font-semibold py-3.5 text-sm whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('clientName')}
          </th>

          <th scope="col" className="px-3 font-semibold py-3.5 text-sm whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('address')}
          </th>

          <th scope="col" className="px-3 font-semibold py-3.5 text-sm whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('date')}
          </th>

          <th scope="col" className="px-3 font-semibold py-3.5 text-sm whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('payment')}
          </th>

          <th scope="col" className="px-3 font-semibold py-3.5 text-sm whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('shipping')}
          </th>

          <th scope="col" className="px-3 font-semibold py-3.5 text-sm whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('total')}
          </th>

          {permissions.view || permissions.delete ?
            <th scope="col" className="dropDown font-semibold px-4 py-3.5 text-sm text-left rtl:text-right text-gray-500">
              {t('option')}
            </th>
            :
            null
          }
        </tr>
      </thead>

      <tbody className="bg-white divide-y divide-gray-200">
        {/* Show the Search result only when search keyword is set */}
        {searchQuery === "" ?
          allDeliveries?.allDeliveries.slice(startingIndex, startingIndex + 10).map(order => {
            return (
              <tr key={order.id}>
                <td className="px-4 py-4 text-sm font-medium check-box">
                  <div className='relative flex'>
                    <input type="checkbox" checked={checkedItems.some(checkedItem => checkedItem.id === order.id)} onChange={() => handleCheck(order.id)} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                    <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                </td>
                <td className="px-3 py-3 text-sm">
                  <div>
                    <h2 className="text-gray-700">{order.orderNumber}</h2>
                  </div>
                </td>
                <td className="px-3 py-3 text-sm">
                  <p className="text-gray-500">{order?.client ? order?.client?.name : "N/A"}</p>
                </td>
                <td className="px-3 py-4 text-sm whitespace-nowrap">
                  <p className="text-gray-500">
                    {order?.addressClient?.address},
                    <span className='ml-1'>
                      {order?.addressClient?.city}
                    </span>
                  </p>
                </td>
                <td className="px-3 py-4 text-sm">
                  <p className="text-gray-500">{new Date(order.createdAt).toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })}</p>
                </td>

                <td className="px-3 py-4 text-sm whitespace-nowrap">
                  <p className="text-gray-500">{order.paymentMethod !== null ? order.paymentMethod.bankName : "N/A"}</p>
                </td>

                <td className="px-3 py-4 text-sm">
                  <p className="text-gray-500">{order.deliveryMethod !== null ? order.deliveryMethod.name : "N/A"}</p>
                </td>

                <td className="px-3 py-4 text-sm">
                  <p className="text-gray-500">
                    {order.deliveryMethod ?
                      order?.deliveryMethod?.price + order?.deliveryProduct?.reduce(
                        (accumulator, product: any) => accumulator + (product?.price - order?.discount) * product?.quantity, 0
                      )
                      :
                      order?.deliveryProduct?.reduce(
                        (accumulator, product: any) => accumulator + (product?.price - order?.discount) * product?.quantity, 0
                      )}
                  </p>
                </td>

                {permissions.view || permissions.delete ?
                  <td className="px-3 py-4 text-sm dropDown">
                    <OrdersDropDown permissions={permissions} direction={direction} id={order.id} setSelectedIdForDelete={setSelectedIdForDelete} setDeleteConfPopup={setDeleteConfPopup} />
                  </td>
                  : null
                }
              </tr>
            )
          })
          :
          searchResult?.map(order => (
            <tr key={order.id}>
              <td className="px-4 py-4 text-sm font-medium check-box">
                <div className='relative flex'>
                  <input type="checkbox" checked={checkedItems.some(checkedItem => checkedItem.id === order.id)} onChange={() => handleCheck(order.id)} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                  <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
              </td>
              <td className="px-3 py-3 text-sm">
                <div>
                  <h2 className="text-gray-700">{order.orderNumber}</h2>
                </div>
              </td>
              <td className="px-3 py-3 text-sm">
                <p className="text-gray-500">{order?.client ? order?.client?.name : "N/A"}</p>
              </td>
              <td className="px-3 py-4 text-sm whitespace-nowrap">
                <p className="text-gray-500">
                  {order?.addressClient?.address},
                  <span className='ml-1'>
                    {order?.addressClient?.city}
                  </span>
                </p>
              </td>
              <td className="px-3 py-4 text-sm">
                <p className="text-gray-500">{new Date(order.createdAt).toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })}</p>
              </td>

              <td className="px-3 py-4 text-sm whitespace-nowrap">
                <p className="text-gray-500">{order.paymentMethod !== null ? order.paymentMethod.bankName : "N/A"}</p>
              </td>

              <td className="px-3 py-4 text-sm">
                <p className="text-gray-500">{order.deliveryMethod !== null ? order.deliveryMethod.name : "N/A"}</p>
              </td>

              <td className="px-3 py-4 text-sm">
                <p className="text-gray-500">
                  {order.deliveryMethod ?
                    order?.deliveryMethod?.price + order?.deliveryProduct?.reduce(
                      (accumulator, product: any) => accumulator + (product?.price - order?.discount) * product?.quantity, 0
                    )
                    :
                    order?.deliveryProduct?.reduce(
                      (accumulator, product: any) => accumulator + (product?.price - order?.discount) * product?.quantity, 0
                    )}
                </p>
              </td>

              {permissions.view || permissions.delete ?
                <td className="px-3 py-4 text-sm dropDown">
                  <OrdersDropDown permissions={permissions} direction={direction} id={order.id} setSelectedIdForDelete={setSelectedIdForDelete} setDeleteConfPopup={setDeleteConfPopup} />
                </td>
                : null
              }
            </tr>
          ))
        }
      </tbody>
    </table>
  )
}

export default OrdersTable